
import { mapGetters, mapActions } from "vuex";
export default {
    props: ['email'],
    components: {
        vcFormField		: () => import("../../components/pages/form-field.vue")
    },
    data() {
        return { 
            data_password: {
                password                : null,
                password_confirmation   : null
            }
        };
    },
    async mounted(){

		this.$root.$on('update-field-value', this.updateFieldValue);
    },
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang	: 'getterStoreLang',
            getterLogin     : 'getterLogin'
        }),
        getDataPassword(){
            return this.data_password;
        }
    },
    methods: {
        ...mapActions({
            updateCustomerPassword: 'updateCustomerPassword'
        }),
		updateFieldValue(data){
            this.data_password[data.field] = data.value;
		},
        updatePassword(){
            
            this.$root.$emit('change-loading', true);
            this.updateCustomerPassword({ email: this.email, password: this.data_password.password }).then( (result_password) => {
                
                this.data_password.password             = null;
                this.data_password.password_confirmation= null;
                if( this.getterLogin ){
                    
                    document.getElementById('reset-form').click();
                }
                else{
                    
                    this.$router.push('/account/login');
                }
                this.$root.$emit('change-loading', false);
            });
        }
    }
}
